import React from "react";
import {Switch} from "./Switch";
import type {SwitchProps} from "./Switch";
import {InputLayout} from "./InputLayout";
import type {InputLayoutProps} from "./InputLayout";

type SwitchFieldProps = InputLayoutProps & SwitchProps;

export const SwitchField: React.FC<SwitchFieldProps> = (props) => {
	return (
		<InputLayout {...props}>
			<Switch {...props} label={``}/>
		</InputLayout>
	);
};
